import WelcomeBanner from './WelcomeBanner.jsx';

export default WelcomeBanner;
